import {createUseStyles} from 'react-jss';
import MediaQueries from '../../../v2/style-helper/MediaQueries';

export default createUseStyles({
  securityCert: {
    right: '1em',
    
    [MediaQueries.phone]: {
      position: 'absolute',
      right: props => !props.isRTL && 0,
      left: props => props.isRTL && 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      maxWidth: '26%',
      padding: [0, '0.5em'],
      '-ms-transform': 'translateY(-50%)', // only for IE
      cursor: props => props.authority !== 'default' && 'pointer',
    },
  },
});
